import { styled } from "@vitality-ds/system";
import BaseCalendarStyles from "./styles/BaseCalendar.styles";
import TopBarContainerStyles from "./styles/TopBarContainer.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseCalendar = styled("div", BaseCalendarStyles);
export var TopBarContainer = styled("div", TopBarContainerStyles);